export default __webpack_public_path__ + "static/media/icons_company_info.dfd323e2.svg";